// extracted by mini-css-extract-plugin
module.exports = {"definitionList":"DefinitionList-hashed__definitionList__3qkLq","hasTitle":"DefinitionList-hashed__hasTitle__1ba_H","title":"DefinitionList-hashed__title__UWsHx"};